import { render, staticRenderFns } from "./DispatchListTable.vue?vue&type=template&id=ac0f95de&scoped=true"
import script from "./DispatchListTable.vue?vue&type=script&lang=js"
export * from "./DispatchListTable.vue?vue&type=script&lang=js"
import style0 from "./DispatchListTable.vue?vue&type=style&index=0&id=ac0f95de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0f95de",
  null
  
)

export default component.exports